<script setup>
import { computed } from 'vue'

import { searchResultTypeEnum, useWebSiteStore } from '@/stores/web-site.store'
import { useDetectDevice } from '@/composables/device'

import EquipmentDetail from '@/components/shared/EquipmentDetail.vue'
import StaffDetail from '@/components/shared/StaffDetail.vue'
import GroupEdit from '@/components/shared/GroupEdit.vue'
import ProjectDetail from '@/components/shared/ProjectDetail.vue'
import CompanyDetail from '@/components/shared/CompanyDetail.vue'
import ListingDetail from '@/components/shared/ListingDetail.vue'
import ListingItemDetail from '@/components/shared/ListingItemDetail.vue'
import BudgetDocumentDetail from '@/components/accounting/BudgetDocumentDetail.vue'

const webSiteStore = useWebSiteStore()
const { isMobile } = useDetectDevice()

const detailComponents = {
  [searchResultTypeEnum.EQUIPMENT]: EquipmentDetail,
  [searchResultTypeEnum.STAFF]: StaffDetail,
  [searchResultTypeEnum.GROUP]: GroupEdit,
  [searchResultTypeEnum.PROJECT]: ProjectDetail,
  [searchResultTypeEnum.COMPANY]: CompanyDetail,
  [searchResultTypeEnum.RATE_CARD]: ListingDetail,
}

const detail = computed(() => webSiteStore.searchResultDetail)
const isQuote = computed(() => detail.value?.type === searchResultTypeEnum.QUOTE)
const component = computed(() => (detail.value?.isItem ? ListingItemDetail : detailComponents[detail.value?.type]))
</script>

<template>
  <q-dialog
    :model-value="detail !== null"
    :maximized="isMobile || isQuote"
    class="dialog-xs"
    @hide="webSiteStore.closeSearchResultDetail()"
  >
    <template v-if="detail">
      <budget-document-detail
        v-if="isQuote"
        :item-id="detail.item"
        @cancel="webSiteStore.closeSearchResultDetail()"
        @update="webSiteStore.closeSearchResultDetail()"
      />
      <component
        :is="component"
        v-else
        :model-value="detail.item"
        @cancel="webSiteStore.closeSearchResultDetail()"
        @update="webSiteStore.closeSearchResultDetail()"
        @delete="webSiteStore.closeSearchResultDetail()"
      />
    </template>
  </q-dialog>
</template>
